export enum DeleteAccountTypeEnum {
    PROGRESS_CENTER = 'PROGRESS_CENTER',
    SITE_WALK = 'SITE_WALK',
}
